import React from 'react'
import Hero from '../../components/Hero/Hero'
import Contact from '../../components/Contact/Contact'
import Footer from '../../components/Footer/Footer'

const Home = () => {
  return (
    <>
      <Hero />
      <Contact />
      <Footer />
    </>
  )
}

export default Home;
